import { type ReactNode, useEffect, useState } from "react";
import { Navigate } from "@tanstack/react-router";

import { PATIENT_HOME_PATH, PATIENT_LOGIN_PATH } from "./patientLoginPath";
import {
  currentPatientSession,
  subscribePatientSessionChange,
} from "./patientSession";

/**
 * 患者の SAS のセッションが無ければ /patient/login へ移す（web のフラグが ON の患者のページ。Issue #473）。
 *
 * ほかのタブでログアウトされたときや、ほかのタブで別の患者がログインしたときは、前の患者の画面と
 * 取得した内容のキャッシュを残さないよう、読み込み直して移す（ログインのままならホーム、無ければログインの画面）。
 * このタブの中の変更（ログアウト、401 での削除、ログイン）は、変えた側が読み込み直して移すので、ここでは移さない
 * （移すと、変えた側の notice 付きの移動とぶつかる）。
 */
export function PatientSessionGuard({ children }: { children: ReactNode }) {
  const [signedIn] = useState(() => currentPatientSession() !== null);

  useEffect(
    () =>
      subscribePatientSessionChange(({ inOtherTab }) => {
        if (!inOtherTab) return;
        window.location.replace(
          currentPatientSession() !== null
            ? PATIENT_HOME_PATH
            : PATIENT_LOGIN_PATH,
        );
      }),
    [],
  );

  if (!signedIn) return <Navigate to={PATIENT_LOGIN_PATH} replace />;
  return <>{children}</>;
}
